<template>
  <div class="servers-view" :class='$layout.isMobile ? "mobile" : undefined'>
    <Section id="predef" :header="$t('server_predef')">

      <div class="flex-row justify-content-center" style="margin-bottom: 50px">
        <Askme/>
      </div>

      <div v-if="error && servers.length <= 0" class="error">{{$t(error)}}</div>
      <div v-else>
        <div v-if="0==servers.length">
          <p>{{$t('loading')}}<LoaderSVG/></p>
        </div>
        <div v-else class="servers-viewport">
          <div class="flex-row servers">
            <ServerSummary v-for="server in servers" v-bind:key="server.id" :server="server" @order="Order"/>
          </div>
        </div>
      </div>
      <div v-if="preview" class="flex-row show-all">
        <BorderlessButton href="/servers">Показать все сервера</BorderlessButton>
      </div>
    </Section>
  </div>
</template>

<script>
import BorderlessButton from "@/components/BorderlessButton";
import Section from "@/components/Section";
import ServerSummary from "@/components/ServerSummary";
import LoaderSVG from "@/components/LoaderSVG";
import Askme from "@/components/Askme";
import { start_updates, stop_updates } from "@/code/servers";

export default {
  name: 'Servers',
  components: {
    BorderlessButton,
    Section,
    ServerSummary,
    LoaderSVG,
    Askme,
  },
  props: {
    preview: {type: Boolean, default: false},
  },
  data: function() {
    return {
      error: undefined,
      servers: [],
    }
  },
  watch: {
    '$servers.all'() {
      this.UpdateServers();
    },
    '$servers.error'(value) {
      this.error = value ? value.detail : undefined;
    },
  },
  created() {
    this.error = undefined;
    this.UpdateServers();
    start_updates();
  },
  destroyed() {
    stop_updates();
  },
  methods: {
    UpdateServers() {
      if (this.preview) {
        this.servers = this.$servers.all.slice(0,4);
      } else {
        this.servers = this.$servers.all;
      }
    },
    Order: function(server) {
      const base64 = btoa(JSON.stringify(server, undefined, 2));
      this.$storage.lastOrder = base64;
      const push = {name: "Order"};
      this.$router.push(push);
    }
  }
}
</script>

<style scoped lang="scss">

.servers-view.mobile {
  .servers-viewport {
    height: $server-details-h;
    width: 100vw;
    box-sizing: border-box;
    transform: translateX(-$side-gap-small);
    overflow-x: scroll;
    display: flex;

    .servers {
      display: flex;
      padding-left: 30px;
      padding-right: 30px;
    }

  }

  .servers {
    gap: 20px;
    left: 0;
  }

  .show-all {
    margin-top: 22px;
  }
}

.servers-view {
  .servers-viewport {
    .servers {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
    }
  }

  .show-all {
    margin-top: 50px;
    flex-flow: row-reverse;
  }
}

</style>
